import request from '@/utils/request'

// 获取轮播图列表
export function getHomeBanners() {
  return request({
    url: '/cms/home/banner/public/list',
    method: 'get'
  })
}

// 获取核心优势列表
export function getHomeAdvantages() {
  return request({
    url: '/cms/home/advantage/public/list',
    method: 'get'
  })
}

// 获取板块配置文案
export function getHomeConfigs(query) {
  return request({
    url: '/cms/home/config/public/list',
    method: 'get',
    params: query
  })
}
